(function () {
    function getBasketTotalPrice() {
        if (
            window.BX &&
            window.BX.Sale &&
            window.BX.Sale.BasketComponent &&
            window.BX.Sale.BasketComponent.result &&
            typeof window.BX.Sale.BasketComponent.result.allSum !== 'undefined'
        ) {
            return Number(window.BX.Sale.BasketComponent.result.allSum) || 0;
        }

        return null;
    }

    function renderBasketMinPriceWarning() {
        const minPrice = 500;
        const basketTotal = getBasketTotalPrice();
        const anchors = document.querySelectorAll('[data-anchor="min-price-total"]');

        if (!anchors.length || basketTotal === null) {
            return;
        }

        anchors.forEach((anchor) => {
            anchor.innerHTML = '';

            if (basketTotal >= minPrice) {
                return;
            }

            const warning = document.createElement('div');
            warning.className = 'warning';

            warning.innerHTML = `
                <svg width="2" height="15" viewBox="0 0 2 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.0498 1V9M1.09961 13V13.1L1 13.1002V13H1.09961Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            `;

            const info = document.createElement('div');
            info.className = 'basket__min-price-info';

            const firstText = document.createElement('p');
            firstText.className = 'basket__min-price-text';
            firstText.textContent = 'Минимальная сумма заказа 500 рублей';

            const secondText = document.createElement('p');
            secondText.className = 'basket__min-price-text';
            secondText.textContent = 'Пожалуйста, добавьте ещё товаров в корзину';

            info.appendChild(firstText);
            info.appendChild(secondText);

            anchor.appendChild(warning);
            anchor.appendChild(info);
        });
    }

    if (window.BX && typeof window.BX.addCustomEvent === 'function') {
        window.BX.addCustomEvent('onCompleteAction', (eventData) => {
            if (!eventData || !eventData.action) {
                return;
            }

            if (String(eventData.action).indexOf('loadBasket') === 0) {
                renderBasketMinPriceWarning();
            }
        });
    }

    renderBasketMinPriceWarning();
})();
